
import { create } from 'zustand';

type DialogContent = 'flows' | 'confirmation' | 'custom';

type DialogState = {
  isOpen: boolean;
  title: string;
  content: DialogContent;
  data: any;
  open: (params: { title: string; content: DialogContent; data?: any }) => void;
  close: () => void;
};

export const useDialogStore = create<DialogState>((set) => ({
  isOpen: false,
  title: '',
  content: 'custom',
  data: null,
  open: ({ title, content, data }) => set({ isOpen: true, title, content, data }),
  close: () => set({ isOpen: false }),
}));
